export default __webpack_public_path__ + "static/media/backGround.8a47fb00.png";